import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography'


const RequestInfoSkeleton = () => {

    return (
        <>
            <Typography component="div" variant="h6">
                <Skeleton width="50%" />
            </Typography>
            <Typography variant="body1" gutterBottom>
                <Skeleton height={25} width="60%" />
            </Typography>
            <Typography variant="body2" gutterBottom>
                <Skeleton height={20} width="60%" />
            </Typography>

            <Typography variant="h6" gutterBottom>
                <Skeleton height={40} width="50%" />
            </Typography>
            <Typography variant="body1" gutterBottom>
                <Skeleton height={25} width="75%" />
            </Typography>
            <Typography variant="body2" gutterBottom>
                <Skeleton height={25} width="75%" />
            </Typography>
        </>
    );
}

export default RequestInfoSkeleton;